export const authNavigation = {
	redirectToAuthPage() {
		if (window.location.pathname.startsWith('/auth')) return;

		window.location.assign('/auth');
	},

	redirectToHomePage() {
		window.location.assign('/');
	},
};
